import { applicationRedirectUrl } from '@/app/(platform)/application/_utils/application-redirect-url';

const SIGN_UP_PATH = '/sign-up';

/**
 * The medium every interview account is stamped with. Written into the ACCOUNT RECORD at sign-up
 * (Clerk `unsafeMetadata`), which is the one number that survives a reader declining cookies, so it
 * is how interview accounts are counted against Labs accounts (`lab-*`). Deliberately does NOT start
 * with `lab`: the Labs series is read with a starts-with filter and must not absorb these.
 */
export const INTERVIEW_UTM_MEDIUM = 'interview-embed';

export interface InterviewSignUpParams {
  email?: string;
  externshipId?: number;
  guideSource: string;
  /**
   * The newsletter choice they already made on the scorecard. Only sent when they were asked (an
   * email was given): absent means sign-up keeps its own default, as with the Labs handoff.
   */
  newsletter?: boolean;
  pack: string;
}

export function interviewSignUpHref({
  email,
  externshipId,
  guideSource,
  newsletter,
  pack,
}: InterviewSignUpParams): string {
  const params = new URLSearchParams({
    utm_campaign: 'labs_interview',
    utm_content: pack,
    utm_medium: INTERVIEW_UTM_MEDIUM,
    utm_source: guideSource,
  });
  if (email) {
    params.set('email', email);
  }
  if (externshipId) {
    params.set('redirect_url', applicationRedirectUrl(externshipId));
  }
  if (newsletter !== undefined) {
    params.set('newsletter', newsletter ? '1' : '0');
  }
  return `${SIGN_UP_PATH}?${params.toString()}`;
}
